import React from 'react'
import PropTypes from 'prop-types'
import { updateObject } from 'helpers/objectHelpers'
import FormCheckbox from 'components/forms/bases/FormCheckbox'
import FormSelect from 'components/forms/bases/FormSelect'

const array = [
  { label: 'Primary', value: 'primary' },
  { label: 'Secondary', value: 'secondary' },
];

const ThemeForm = ({
  valueSettings,
  valueSettings: {
    basic = '',
    selectStyle = 'primary',
  },
  onChangeSettings,
}) => {
  const handleChange = (val, key) => {
    return onChangeSettings(updateObject(valueSettings, { [key]: val }))
  }
  return (
    <div style={{ padding: 15 }}>
      <FormCheckbox
        label="Basic Style"
        value={basic}
        onChange={(val) => handleChange(val, 'basic')}
      />
      <FormSelect
        value={selectStyle}
        label="Style Theme"
        options={array}
        onChange={(val) => handleChange(val, 'selectStyle')}
        style={{width: '70%'}}
      />
    </div>
  )
}

ThemeForm.propTypes = {}
ThemeForm.defaultProps = {}

export default ThemeForm



// WEBPACK FOOTER //
// ./src/components/forms/ThemeForm.js